import { HandbookFilter } from "features/handbook/model/handbookFilter";
import { Handbook } from "features/handbook/model/handbook";
import { PagedResponse } from "shared/model/api";
import { agroApi } from "shared/api/agroApi";

export const handbook = agroApi.injectEndpoints({
  endpoints: (builder) => ({
    // POST /{slug}/get-all (пагинация)
    getHandbook: builder.query<
      PagedResponse<Handbook>,
      { slug: string; filter: HandbookFilter }
    >({
      query: ({ slug, filter }) => ({
        url: `/${slug}/get-all`,
        method: "POST",
        body: JSON.stringify(filter),
      }),
      providesTags: () => [{ type: "Handbook" as const, id: "LIST" }],
    }),

    addServiceToAll: builder.mutation<
      PagedResponse<unknown>,
      { slug: string; serviceCode: string }
    >({
      query: ({ slug, serviceCode }) => ({
        url: `/${slug}/add-service-to-all?serviceCode=${encodeURIComponent(
          serviceCode
        )}`,
        method: "POST",
      }),
      invalidatesTags: [{ type: "Handbook", id: "LIST" }],
    }),

    // GET /{slug}/{id}
    getHandbookById: builder.query<
      PagedResponse<Handbook>,
      { slug: string; id: number }
    >({
      query: ({ slug, id }) => ({
        url: `/${slug}/${id}`,
        method: "GET",
      }),
      providesTags: (_result, _error, arg) => [
        { type: "Handbook" as const, id: arg.id },
        { type: "Handbook" as const, id: "LIST" },
      ],
    }),

    // POST /{slug}
    addHandbook: builder.mutation<
      PagedResponse<Handbook>,
      {
        slug: string;
        body: Pick<Handbook, "nameRu" | "nameKy"> & Partial<Handbook>;
      }
    >({
      query: ({ slug, body }) => ({
        url: `/${slug}`,
        method: "POST",
        body: JSON.stringify(body),
      }),
      invalidatesTags: [{ type: "Handbook", id: "LIST" }],
    }),

    // PUT /{slug}
    editHandbook: builder.mutation<
      PagedResponse<Handbook>,
      { slug: string; body: Required<Pick<Handbook, "id">> & Partial<Handbook> }
    >({
      query: ({ slug, body }) => ({
        url: `/${slug}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "Handbook", id: "LIST" }],
    }),

    removeServiceFromAll: builder.mutation<
      PagedResponse<unknown>,
      { slug: string; serviceCode: string }
    >({
      query: ({ slug, serviceCode }) => ({
        url: `/${encodeURIComponent(
          slug
        )}/remove-service-from-all?serviceCode=${encodeURIComponent(
          serviceCode
        )}`,
        method: "POST",
      }),
      invalidatesTags: [{ type: "Handbook", id: "LIST" }],
    }),

    // DELETE /{slug}/{id}
    remove: builder.mutation<
      PagedResponse<Handbook>,
      { slug: string; id: number }
    >({
      query: ({ slug, id }) => ({
        url: `/${slug}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Handbook", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetHandbookQuery,
  useGetHandbookByIdQuery,
  useAddServiceToAllMutation,
  useRemoveServiceFromAllMutation,
  useAddHandbookMutation,
  useEditHandbookMutation,
  useRemoveMutation,
} = handbook;
